module.exports = __webpack_public_path__ + "static/media/spades-king.339fd503.png";